
let teaserId;
const teaserSliders = document.querySelectorAll('.slider');

const sliderInit = function() {
    teaserSliders.forEach((teaserEl) => {
        teaserId = teaserEl.getAttribute('data-slider-id');

        let teaserSwiper = new Swiper(`#slider--${teaserId}`, {

            loop: true,
            slidesPerView: 1,
            spaceBetween: 40,

            // navigation: {
            //    nextEl: '.swiper-btn-next',
            //    prevEl: '.swiper-btn-prev',
            //    disabledClass: "bg-primary/[.8]",
            //    lockClass: "hidden"
            // },

            speed: 1200,
            autoplay: {
               delay: 6000,
               disableOnInteraction: false,
            },
        });
    });
}

export {sliderInit }
